/** Default questions shared by the form editor, public forms, and templates. */
export const INTAKE_QUESTIONS = {
  full_name: { label: "Your name" },
  email: {
    label: "Email address",
    description:
      "Your email lets you save your progress and access your portal.",
  },
  phone: { label: "Phone number" },
  business_type: { label: "What kind of business do you own?" },
  ownership_duration: { label: "How long have you owned the business?" },
  annual_revenue: {
    label: "How much did your business make in sales over the last 12 months?",
    description: "Before expenses. A rough number is fine.",
  },
  sell_motivation: {
    label: "What’s making you think about selling?",
    description: "Choose any that fit.",
  },
  seller_timeline: { label: "When would you like to sell your business?" },
  contact_preference: { label: "How would you like {First} to contact you?" },
  budget_range: {
    label: "How much would you like to spend on a business?",
    description: "The total price, including any money you plan to borrow.",
  },
  buyer_timeline: { label: "When would you like to buy a business?" },
  buyer_experience: { label: "Have you owned a business before?" },
  industries_of_interest: {
    label: "What kinds of businesses interest you?",
    description: "Choose any that interest you, or skip this for now.",
  },
} as const;

export const SELLER_REASON_LABELS = {
  considering_retirement: "I’m thinking about retiring or stepping back",
  received_offer: "A buyer has contacted me",
  exploring_liquidity: "I’d like to sell part of the business",
  planning_transition: "I’m planning for someone else to take over",
  just_curious: "I’m curious about my options",
} as const;

/** Only add platform help to its matching default question, never custom copy. */
export function defaultIntakeQuestionHelp(
  key: string,
  label: string,
): string | undefined {
  const copy = INTAKE_QUESTIONS[key as keyof typeof INTAKE_QUESTIONS];
  return copy?.label === label && "description" in copy
    ? copy.description
    : undefined;
}
